/* eslint-disable import/no-anonymous-default-export */

export default {
  INIT: 'USER/INIT',
  LOGIN: 'USER/LOGIN',
  UPDATE_USER: 'USER/UPDATE_USER',
}
